import { Component, computed, input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import {
  iconoirBell,
  iconoirCheck,
  iconoirList,
  iconoirMail,
  iconoirMinus,
  iconoirNavArrowDown,
  iconoirPlus,
  iconoirSearch,
  iconoirWarningTriangle,
  iconoirLogOut,
  iconoirEditPencil,
  iconoirKey,
  iconoirClock,
} from '@ng-icons/iconoir';

const ICONS = {
  'warning-triangle': iconoirWarningTriangle,
  search: iconoirSearch,
  'nav-arrow-down': iconoirNavArrowDown,
  check: iconoirCheck,
  mail: iconoirMail,
  bell: iconoirBell,
  list: iconoirList,
  logout: iconoirLogOut,
  'edit-pencil': iconoirEditPencil,
  key: iconoirKey,
  clock: iconoirClock,
  plus: iconoirPlus,
  minus: iconoirMinus,
} satisfies Record<string, string>;

export type IconName = keyof typeof ICONS;

@Component({
  selector: 'ez-icon',
  imports: [NgIcon],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  host: {
    'aria-hidden': 'true',
  },
})
export class IconComponent {
  readonly name = input.required<IconName>();
  readonly size = input('1em');

  protected readonly svg = computed(() => ICONS[this.name()]);
}
